module.exports = ".content {\r\n    margin: 40px 0px 60px 0px;\r\n}"